import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@/shared/i18n';
import './index.css';
import { AppProviders } from '@/app/providers/AppProviders';
import { AppRouter } from '@/app/router';
import { PreviewBanner } from '@/shared/components/PreviewBanner';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <AppProviders>
      <PreviewBanner />
      <AppRouter />
    </AppProviders>
  </StrictMode>,
);
